import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { AnimatedLogoMark } from "#/components/logo";
import { UI_STRINGS, useI18n } from "#/lib/i18n";

/** Router-level `defaultNotFoundComponent` — covers every `notFound()` thrown
 * anywhere (unknown slug, unmatched path, …), not just a specific route. */
export function NotFoundPage() {
	const { locale, dir } = useI18n();
	const t = UI_STRINGS[locale].notFound;

	return (
		<div className="flex min-h-screen flex-col items-center justify-center gap-8 bg-canvas px-6 py-20 text-center">
			<AnimatedLogoMark mode="enter" className="h-20 w-auto" />

			<div className="flex flex-col gap-3">
				<span className="mx-auto inline-flex items-center gap-1.5 rounded-full bg-teal-50 px-3 py-1 text-xs font-bold tracking-wide text-teal-600">
					{t.eyebrow}
				</span>
				<h1 className="font-display text-3xl font-bold text-navy sm:text-4xl">
					{t.title}
				</h1>
				<p className="mx-auto max-w-md text-sm text-muted sm:text-base">
					{t.description}
				</p>
			</div>

			<Link
				to="/"
				className="inline-flex items-center gap-2 rounded-full bg-navy px-6 py-3.5 text-sm font-bold text-white shadow-lift transition-all hover:-translate-y-0.5 hover:bg-navy-600 active:translate-y-0"
			>
				{t.cta}
				<ArrowRight
					className={`h-4 w-4 ${dir === "rtl" ? "rotate-180" : ""}`}
				/>
			</Link>
		</div>
	);
}
